import Who from './Who';
import WhoContainer from './Who.container';
export default WhoContainer(Who);

//# sourceMappingURL=index.js.map